import { License } from '@/types/license';
import { AppStore } from '..';
import api, { AbortedRequestError } from '../../api';

export default function FetchSessionLicenses(store: AppStore) {
  store.dispatch({
    type: 'FETCH_SESSION_LICENSES_START',
  });

  return api
    .REST('GET', 'licenses', store, {
      requireSessionUser: true,
    })
    .then((response) => {
      const licenses: Array<License> = response.Licenses;
      const fetchedSerials = licenses.map((license) => license.Serial);
      store.dispatch({
        type: 'FETCH_SESSION_LICENSES_SUCCESS',
        licenses,
        fetchedSerials,
      });
    })
    .catch((error) => {
      if (error instanceof AbortedRequestError) {
        store.dispatch({
          type: 'FETCH_SESSION_LICENSES_ABORT',
        });
        return;
      }
      store.dispatch({
        type: 'FETCH_SESSION_LICENSES_FAIL',
        message: error.message || 'Unable to load licenses',
      });
    });
}
